import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

/*export const getListAudit = createAsyncThunk('/history_audit/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listManagementAudit/${userId}`, {})
    return response.data;
})*/

export const getListAudit = createAsyncThunk(
    '/history_audit/content',
    async ({ page, search, type, limit }) => {
        const userId = localStorage.getItem("userId");

        const response = await axios.get(
            `${process.env.REACT_APP_API_ENDPOINT}/listManagementAudit/${userId}`,
            {
                params: {
                    page: page,
                    search: search,
                    type: type,
                    limit: limit
                }
            }
        );

        //console.log("API RESPONSE", response.data);

        return response.data;
    }
);

export const dashboardAuditHistorySlice = createSlice({
    name: 'history_audit',
    initialState: {
        isLoading: false,
        history_audit: []
    },

    /*extraReducers: {
        [getListAudit.pending]: state => {
            state.isLoading = true
        },
        [getListAudit.fulfilled]: (state, action) => {
            state.history_audit = action.payload.data
            state.isLoading = false
        },
        [getListAudit.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getListAudit.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getListAudit.fulfilled, (state, action) => {
                state.history_audit =
                    Array.isArray(action.payload?.data)
                        ? action.payload.data
                        : [];

                state.isLoading = false;
            })
            .addCase(getListAudit.rejected, (state) => {
                state.isLoading = false;
                console.log(state);
            });
    }
})

export default dashboardAuditHistorySlice.reducer